<div class="section-title">
    <h2>What's New?</h2>

    <div class="right-group">
        <span class="explore" (click)="routeToGames()">Explore All</span>
        <button class="arrow left" (click)="scrollLeft()">
            ←
        </button>

        <button class="arrow right" (click)="scrollRight()">
            →
        </button>
    </div>
</div>


<div id="new-slider" class="cards-container" *ngIf="!gamesLoaded">
    <div *ngFor="let _ of skeletonItems" class="game-card skeleton-card">
        <div class="skeleton-block skeleton-image"></div>
        <div class="game-info">
            <div class="skeleton-block skeleton-title"></div>
            <div class="skeleton-block skeleton-chip"></div>
        </div>
    </div>
</div>

<div id="new-slider" class="cards-container" *ngIf="gamesLoaded">
    <div *ngFor="let game of visibleGames" class="game-card">
        <a (click)="routeToGameDetail(game.id, game.name)">
            <img [src]="'data:image/png;base64,' + game.image" alt="{{game.name}}" />
            <div class="game-info">
                <h4>{{ game.name }}</h4>
                <p>{{ game.genre }}</p>
            </div>
        </a>
    </div>
</div>
